/**
 * 用户组与用户列表功能
 * @Author:wuTao
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config'

import {component_tool, framework_tool,utils_tool} from '@/tool';
let {Session} = utils_tool;
let {WizCard} = component_tool;
let {WizContainer, WizReduxTemplate} = framework_tool;

class GroupUserList extends WizContainer {

  componentName = 'GroupUserList';

  constructor(props) {
    super(props);
    this.state = {};
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.record) {
      initialValue = history.location.record;
      Session.set('groupRecord', initialValue)
    } else {
      initialValue = Session.get('groupRecord') || {};
    }
    this.initialValue = initialValue;

  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleGroupUser(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let groupName = '';

    let groupRecord = this.initialValue;
    let state = null;
    let groupId = null;
    if (groupRecord){
      groupName = groupRecord.name;
      groupId = groupRecord.id;
      state = groupRecord.state;
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      groupId,
      templateConfig:templateConfig({groupId,state}),
      apiDataFormat: {
        delete: this._handleGroupUser
      },
    });
    let title = '当前用户组:' + groupName;
    return <WizCard>
      <WizReduxTemplate {..._reduxTemplateCofig} />
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(GroupUserList);
